module.exports = __webpack_public_path__ + "img/Blitzoo_Logo.8690025f.png";